import React, { Component } from "react";

import AuthService from "../../../../services/login/auth.service";
import history from "../../login/history";
import Titulo from "../../../generico/TituloPagina";
import Popup from "react-popup";
import $ from "jquery";
import DatosSocio from "../../../generico/DatosSocio";
import CambiarPinTransaccionalService from "../../../../services/autogestion/SolicitarPinTransaccionalService";
import { trackPromise } from "react-promise-tracker";
import TecladoPin from "../../../generico/TecladoPin";
import Paso1 from "../solicitud/Paso1";
import Paso2 from "../solicitud/Paso2";

import StepWizard from "react-step-wizard";

export default class SolicitudPinTransaccional extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    idContrato: undefined,
    pin: undefined,
    confirmPin: undefined,
  });
  returnDataPaso1(_idContrato) {
    this.setState({
      idContrato: _idContrato,
    });
  }
  returnDataPaso2() {
    this.initDataChildren();
  }

  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      // this.paso1.current.checkCuentaDestino();
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Solicitar PIN - Transferencia Interbancaria" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}                        
                      />
                      <Paso2
                        ref={this.paso2}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
